import './fireandsmoke/style';
import FormStructure from './fireandsmoke/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// c:/_Development/Web Inquiry/inquiry-renderer/client_forms/includes.js